import {createSvgIcon} from '../create-svg-icon';

export const ViewArrayIcon = createSvgIcon(
  <path d="M15 7v10H9V7h6zm6-2h-3v14h3V5zm-4 0H7v14h10V5zM6 5H3v14h3V5z" />
, 'ViewArrayOutlined');
